export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/terms": [4],
		"/vault": [5,[2]],
		"/vault/family": [6,[2]],
		"/vault/files/[subjectId]": [7,[2]],
		"/vault/health-summary/[subjectId]": [8,[2]],
		"/vault/login": [9,[2]],
		"/vault/onboarding": [10,[2]],
		"/vault/profile": [11,[2]],
		"/vault/profile/[subjectId]": [12,[2]],
		"/vault/profile/[subjectId]/details": [13,[2]],
		"/vault/profile/[subjectId]/medical-history": [14,[2]],
		"/vault/terms": [15,[2]],
		"/vault/upload/[subjectId]": [16,[2]],
		"/vault/welcome": [17,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';